import React from "react";
import './DefaultCard.scss'

const DefaultCard =({children,padding=true})=>
{
    return(
        <div className="DefaultCard" style={{padding:`${padding?"20px":null}`}}>
            {children}
        </div>
    )
}
export default DefaultCard 